export const routeNames = {
  root: "root",
  mainLogin: "mainLogin",
  mainModules: "mainModules",
  mainHelp: "mainHelp",
  mainDocumentation: "mainDocumentation",
  mainAdminPanel: "mainAdminPanel",
  mainChangePassword: "mainChangePassword",
  mainSupervision: "mainSupervision",
  mainStatDashboard: "mainStatDashboard",
  mainStatCharts: "mainStatCharts",
  mainAccount: "mainAccount",
  mainAccountEdit: "mainAccountEdit",
  mainMapTest: "mainMapTest",
  mainUrlViewer: "mainUrlViewer",

  mwParityRoot: "mwParityRoot",
  mwParityMain: "mwParityMain",
  mwParityAdminPanel: "mwParityAdminPanel",
  mwParityDocumentation: "mwParityDocumentation",

  mwApplicationsRequestsRoot: "mwApplicationsRequestsRoot",
  mwApplicationsRequestsMain: "mwApplicationsRequestsMain",
  mwApplicationsRequestsApplication: "mwApplicationsRequestsApplication",
  mwApplicationsRequestsConsultation: "mwApplicationsRequestsConsultation",
  mwApplicationsRequestsAdminPanel: "mwApplicationsRequestsAdminPanel",

  esApplicationsRequestsRoot: "esApplicationsRequestsRoot",
  esApplicationsRequestsMain: "esApplicationsRequestsMain",
  esApplicationsRequestsApplication: "esApplicationsRequestsApplication",
  esApplicationsRequestsConsultation: "esApplicationsRequestsConsultation",
  esApplicationsRequestsAdminPanel: "esApplicationsRequestsAdminPanel",
  mwExistingRoot: "mwExistingRoot",
  mwExistingMain: "mwExistingMain",
  mwExistingAdminPanel: "mwExistingAdminPanel",

  freqExperimentationRoot: "freqExperimentationRoot",
  freqExperimentationRequestsMain: "freqExperimentationRequestsMain",
  freqExperimentationRequestsAdminPanel: "freqExperimentationRequestsAdminPanel",
  freqExperimentationRequestsBandRequest: "freqExperimentationRequestsBandRequest",
  freqExperimentationRequestsRadarRequest: "freqExperimentationRequestsRadarRequest",
  freqExperimentationRequestsDroneRequest: "freqExperimentationRequestsDroneRequest",
  freqExperimentationRequestsTerrestialRequest: "freqExperimentationRequestsTerrestialRequest",
  freqExperimentationRequestsConsultation: "freqExperimentationRequestsConsultation",

  agencyControlMain: "agencyControlMain",
  agencyControlAdminPanel: "agencyControlAdminPanel",

  restrictedAreasRoot: "restrictedAreasRoot",
  restrictedAreasMain: "restrictedAreasMain",
  restrictedAreasAdminPanel: "restrictedAreasAdminPanel",

  equipmentsMain: "equipmentsMain",
  equipmentsDrafts: "equipmentsDrafts",
  equipmentsApplication: "equipmentsApplication",
  equipmentsAdminPanel: "equipmentsAdminPanel",

  antennasMain: "antennasMain",
  antennasDrafts: "antennasDrafts",
  antennasApplication: "antennasApplication",
  antennasAdminPanel: "antennasAdminPanel",

  pmrMain: "pmrMain",
  pmrAdminPanel: "pmrAdminPanel",
  pmrRequests: "pmrRequests",
  pmrRequest: "pmrRequest",
  pmrConsultation: "pmrConsultation",

  otsMain: "otsMain",
  otsAdminPanel: "otsAdminPanel",
  otsRequests: "otsRequests",
  otsRequest: "otsRequest",

  joMain: "joMain",
  joAdminPanel: "joAdminPanel",
  joRequests: "joRequests",
  joRequest: "joRequest",

  feesMain: "feesMain",
  feesAdminPanel: "feesAdminPanel",

  mwDeploymentSimulationMain: "mwDeploymentSimulationMain",
  mwDeploymentSimulationAdminPanel: "mwDeploymentSimulationAdminPanel",
  mwDeploymentSimulationRequest: "mwDeploymentSimulationRequest",

  surveysRoot: "surveysRoot",
  surveysList: "surveysList",
  survey: "survey",
  surveyCreator: "surveyCreator",
  surveyResults: "surveyResults",
  surveysAdminPanel: "surveysAdminPanel",

  spectrumMain: "spectrumMain",
  spectrumAdminPanel: "spectrumAdminPanel",

  coverageStatisticsRoot: "coverageStatisticsRoot",
  coverageStatisticsMain: "coverageStatisticsMain",
  coverageStatisticsAdminPanel: "coverageStatisticsAdminPanel",

  adminSitesMain: "adminSitesMain",
  adminSitesAdminPanel: "adminSitesAdminPanel",

  typeApprovalsMain: "typeApprovalsMain",
  typeApprovalsDrafts: "typeApprovalsDrafts",
  typeApprovalsApplication: "typeApprovalsApplication",
  typeApprovalsEdit: "typeApprovalsEdit",
  typeApprovalsView: "typeApprovalsView",
  typeApprovalsAdminPanel: "typeApprovalsAdminPanel",

  bctApplicationsDashboard: "bctApplicationsDashboard",
  bctApplicationsDrafts: "bctApplicationsDrafts",
  bctApplicationsNew: "bctApplicationsNew",
  bctApplicationsEdit: "bctApplicationsEdit",
  bctApplicationsView: "bctApplicationsView",
  bctApplicationsAdminPanel: "bctApplicationsAdminPanel",

  comsisRoot: "comsisRoot",
  comsisStationsList: "comsisStationsList",
  comsisStationsMap: "comsisStationsMap",
  comsisStation: "comsisStation",
  comsisRequest: "comsisRequest",
  comsisRequestsList: "comsisRequestsList",
  comsisAdminPanel: "comsisAdminPanel"
}

export const routes = [
  {
    path: "/",
    name: routeNames.root,
    component: () => import("@/views/main/DefaultRedirectView.vue")
  },
  {
    path: "/main/login/:mode?",
    name: routeNames.mainLogin,
    component: () => import("@/views/main/LoginView.vue")
  },
  {
    path: "/main/modules/:mode?",
    name: routeNames.mainModules,
    component: () => import("@/views/main/ModulesView.vue")
  },
  {
    path: "/main/help-page",
    name: routeNames.mainHelp,
    component: () => import("@/views/main/HelpPageView.vue")
  },
  {
    path: "/main/documentation",
    name: routeNames.mainDocumentation,
    component: () => import("@/views/main/DocumentationView.vue")
  },
  {
    path: "/main/admin-panel/:tab?/:subtab?",
    name: routeNames.mainAdminPanel,
    component: () => import("@/views/main/AdminPanelView.vue")
  },
  {
    path: "/main/help-page",
    name: routeNames.mainHelp,
    component: () => import("@/views/main/HelpPageView.vue")
  },
  {
    path: "/main/passwords-management/:mode/:token?",
    name: routeNames.mainChangePassword,
    component: () => import("@/views/main/ChangePasswordView.vue")
  },
  {
    path: "/main/supervision",
    name: routeNames.mainSupervision,
    component: () => import("@/views/main/SupervisionView.vue")
  },
  {
    path: "/main/stat-dashboard",
    name: routeNames.mainStatDashboard,
    component: () => import("@/views/main/StatDashboardView.vue")
  },
  {
    path: "/main/stat-charts/:module/:year/:month",
    name: routeNames.mainStatCharts,
    component: () => import("@/views/main/StatChartsView.vue")
  },
  {
    path: "/main/account",
    name: routeNames.mainAccount,
    component: () => import("@/views/main/AccountView.vue")
  },
  {
    path: "/main/account/:mode",
    name: routeNames.mainAccountEdit,
    component: () => import("@/views/main/AccountView.vue")
  },
  {
    path: "/main/url-viewer/:alias?",
    name: routeNames.mainUrlViewer,
    component: () => import("@/views/main/UrlViewerView.vue")
  },

  {
    path: "/mw-parity",
    name: routeNames.mwParityRoot,
    redirect() {
      return { name: routeNames.mwParityMain }
    }
  },
  {
    path: "/mw-parity/view",
    name: routeNames.mwParityMain,
    component: () => import("@/views/mw-parity/MainView.vue")
  },
  {
    path: "/mw-parity/admin-panel/:tab?/:subtab?",
    name: routeNames.mwParityAdminPanel,
    component: () => import("@/views/mw-parity/AdminPanelView.vue")
  },
  {
    path: "/mw-parity/documentation",
    name: routeNames.mwParityDocumentation,
    component: () => import("@/views/mw-parity/DocumentationView.vue")
  },

  {
    path: "/mw-existing",
    name: routeNames.mwExistingRoot,
    redirect() {
      return { name: routeNames.mwExistingMain }
    }
  },
  {
    path: "/mw-existing/view",
    name: routeNames.mwExistingMain,
    component: () => import("@/views/mw-existing/MainView.vue")
  },
  {
    path: "/mw-existing/admin-panel/:tab?/:subtab?",
    name: routeNames.mwExistingAdminPanel,
    component: () => import("@/views/mw-existing/AdminPanelView.vue")
  },

  {
    path: "/mw-applications-requests",
    name: routeNames.mwApplicationsRequestsRoot,
    redirect() {
      return { name: routeNames.mwApplicationsRequestsMain }
    }
  },
  {
    path: "/mw-applications-requests/start-page",
    name: routeNames.mwApplicationsRequestsMain,
    component: () => import("@/views/mw-applications-requests/MainView.vue")
  },
  {
    path: "/mw-applications-requests/application/:id?",
    name: routeNames.mwApplicationsRequestsApplication,
    component: () => import("@/views/mw-applications-requests/ApplicationView.vue")
  },
  {
    path: "/mw-applications-requests/consultation/:id/:tab?/:subtab?",
    name: routeNames.mwApplicationsRequestsConsultation,
    component: () => import("@/views/mw-applications-requests/ConsultationView.vue")
  },
  {
    path: "/mw-applications-requests/admin-panel/:tab?/:subtab?",
    name: routeNames.mwApplicationsRequestsAdminPanel,
    component: () => import("@/views/mw-applications-requests/AdminPanelView.vue")
  },

  {
    path: "/es-applications-requests",
    name: routeNames.esApplicationsRequestsRoot,
    redirect() {
      return { name: routeNames.esApplicationsRequestsMain }
    }
  },
  {
    path: "/es-applications-requests/start-page",
    name: routeNames.esApplicationsRequestsMain,
    component: () => import("@/views/es-applications-requests/MainView.vue")
  },
  {
    path: "/es-applications-requests/application/:id?",
    name: routeNames.esApplicationsRequestsApplication,
    component: () => import("@/views/es-applications-requests/ApplicationView.vue")
  },
  {
    path: "/es-applications-requests/consultation/:id/:tab?/:subtab?",
    name: routeNames.esApplicationsRequestsConsultation,
    component: () => import("@/views/es-applications-requests/ConsultationView.vue")
  },
  {
    path: "/es-applications-requests/admin-panel/:tab?/:subtab?",
    name: routeNames.esApplicationsRequestsAdminPanel,
    component: () => import("@/views/es-applications-requests/AdminPanelView.vue")
  },

  {
    path: "/freq-experimentation-requests",
    name: routeNames.freqExperimentationRoot,
    redirect() {
      return { name: routeNames.freqExperimentationRequestsMain }
    }
  },
  {
    path: "/freq-experimentation-requests/requests-list",
    name: routeNames.freqExperimentationRequestsMain,
    component: () => import("@/views/freq-experimentation-requests/MainView.vue")
  },
  {
    path: "/freq-experimentation-requests/admin-panel/:tab?/:subtab?",
    name: routeNames.freqExperimentationRequestsAdminPanel,
    component: () => import("@/views/freq-experimentation-requests/AdminPanelView.vue")
  },
  {
    path: "/freq-experimentation-requests/request/band/:id/:requestType?/:testType?",
    name: routeNames.freqExperimentationRequestsBandRequest,
    component: () => import("@/views/freq-experimentation-requests/BandRequestView.vue")
  },
  {
    path: "/freq-experimentation-requests/request/band/:id/:requestType?/:testType?",
    name: routeNames.freqExperimentationRequestsBandRequest,
    component: () => import("@/views/freq-experimentation-requests/BandRequestView.vue")
  },
  {
    path: "/freq-experimentation-requests/request/radar/:id/:requestType?/:testType?",
    name: routeNames.freqExperimentationRequestsRadarRequest,
    component: () => import("@/views/freq-experimentation-requests/RadarRequestView.vue")
  },
  {
    path: "/freq-experimentation-requests/request/drone/:id/:requestType?/:testType?",
    name: routeNames.freqExperimentationRequestsDroneRequest,
    component: () => import("@/views/freq-experimentation-requests/DroneRequestView.vue")
  },
  {
    path: "/freq-experimentation-requests/request/terrestial/:id/:requestType?/:testType?",
    name: routeNames.freqExperimentationRequestsTerrestialRequest,
    component: () => import("@/views/freq-experimentation-requests/TerrestialRequestView.vue")
  },
  {
    path: "/freq-experimentation-requests/consult/:service/:id/:tab?/:subtab?",
    name: routeNames.freqExperimentationRequestsConsultation,
    component: () => import("@/views/freq-experimentation-requests/ConsultationView.vue")
  },

  {
    path: "/agency-control/view",
    name: routeNames.agencyControlMain,
    component: () => import("@/views/agency-control/MainView.vue")
  },
  {
    path: "/agency-control/admin-panel/:tab?/:subtab?",
    name: routeNames.agencyControlAdminPanel,
    component: () => import("@/views/agency-control/AdminPanelView.vue")
  },

  {
    path: "/restricted-areas",
    name: routeNames.restrictedAreasRoot,
    redirect() {
      return { name: routeNames.restrictedAreasMain }
    }
  },
  {
    path: "/restricted-areas/view",
    name: routeNames.restrictedAreasMain,
    component: () => import("@/views/restricted-areas/MainView.vue")
  },
  {
    path: "/restricted-areas/admin-panel/:tab?/:subtab?",
    name: routeNames.restrictedAreasAdminPanel,
    component: () => import("@/views/restricted-areas/AdminPanelView.vue")
  },

  {
    path: "/equipments/existing-equipments",
    name: routeNames.equipmentsMain,
    component: () => import("@/views/equipments/MainView.vue")
  },
  {
    path: "/equipments/drafts-list",
    name: routeNames.equipmentsDrafts,
    component: () => import("@/views/equipments/DraftsListView.vue")
  },
  {
    path: "/equipments/application/:id?",
    name: routeNames.equipmentsApplication,
    component: () => import("@/views/equipments/ApplicationView.vue")
  },
  {
    path: "/equipments/admin-panel/:tab?/:subtab?",
    name: routeNames.equipmentsAdminPanel,
    component: () => import("@/views/equipments/AdminPanelView.vue")
  },
  {
    path: "/equipments",
    redirect() {
      return { name: routeNames.equipmentsMain }
    }
  },

  {
    path: "/antennas/existing-antennas",
    name: routeNames.antennasMain,
    component: () => import("@/views/antennas/MainView.vue")
  },
  {
    path: "/antennas/drafts-list",
    name: routeNames.antennasDrafts,
    component: () => import("@/views/antennas/DraftsListView.vue")
  },
  {
    path: "/antennas/application/:id?",
    name: routeNames.antennasApplication,
    component: () => import("@/views/antennas/ApplicationView.vue")
  },
  {
    path: "/antennas/admin-panel/:tab?/:subtab?",
    name: routeNames.antennasAdminPanel,
    component: () => import("@/views/antennas/AdminPanelView.vue")
  },

  {
    path: "/pmr/view",
    name: routeNames.pmrMain,
    component: () => import("@/views/pmr/MainView.vue")
  },
  {
    path: "/pmr/requests",
    name: routeNames.pmrRequests,
    component: () => import("@/views/pmr/RequestsView.vue")
  },
  {
    path: "/pmr/admin-panel/:tab?/:subtab?",
    name: routeNames.pmrAdminPanel,
    component: () => import("@/views/pmr/AdminPanelView.vue")
  },
  {
    path: "/pmr/request/:id/:requestType?/:serviceType?",
    name: routeNames.pmrRequest,
    component: () => import("@/views/pmr/RequestView.vue")
  },
  {
    path: "/pmr/consult/:id/:tab?/:subtab?",
    name: routeNames.pmrConsultation,
    component: () => import("@/views/pmr/ConsultationView.vue")
  },
  {
    path: "/pmr",
    redirect() {
      return { name: routeNames.pmrMain }
    }
  },

  {
    path: "/ots-applications/view",
    name: routeNames.otsMain,
    component: () => import("@/views/ots/MainView.vue")
  },
  {
    path: "/ots-applications/requests",
    name: routeNames.otsRequests,
    component: () => import("@/views/ots/RequestsView.vue")
  },
  {
    path: "/ots-applications/admin-panel/:tab?/:subtab?",
    name: routeNames.otsAdminPanel,
    component: () => import("@/views/ots/AdminPanelView.vue")
  },
  {
    path: "/ots-applications/request/:id(\\d+)?/:mode?",
    name: routeNames.otsRequest,
    component: () => import("@/views/ots/RequestView.vue")
  },
  {
    path: "/ots-applications",
    redirect() {
      return { name: routeNames.otsMain }
    }
  },

  {
    path: "/jo-applications/view",
    name: routeNames.joMain,
    component: () => import("@/views/jo/MainView.vue")
  },
  {
    path: "/jo-applications/requests",
    name: routeNames.joRequests,
    component: () => import("@/views/jo/RequestsView.vue")
  },
  {
    path: "/jo-applications/admin-panel/:tab?/:subtab?",
    name: routeNames.joAdminPanel,
    component: () => import("@/views/jo/AdminPanelView.vue")
  },
  {
    path: "/jo-applications/request/:id(\\d+)?/:mode?",
    name: routeNames.joRequest,
    component: () => import("@/views/jo/RequestView.vue")
  },
  {
    path: "/jo-applications",
    redirect() {
      return { name: routeNames.joMain }
    }
  },

  {
    path: "/fees/view",
    name: routeNames.feesMain,
    component: () => import("@/views/fees/MainView.vue")
  },
  {
    path: "/fees/admin-panel/:tab?/:subtab?",
    name: routeNames.feesAdminPanel,
    component: () => import("@/views/fees/AdminPanelView.vue")
  },

  {
    path: "/mw-deployment-simulation/view",
    name: routeNames.mwDeploymentSimulationMain,
    component: () => import("@/views/mw-deployment-simulation/MainView.vue")
  },
  {
    path: "/mw-deployment-simulation/admin-panel/:tab?/:subtab?",
    name: routeNames.mwDeploymentSimulationAdminPanel,
    component: () => import("@/views/mw-deployment-simulation/AdminPanelView.vue")
  },
  {
    path: "/mw-deployment-simulation/simulation/:id?",
    name: routeNames.mwDeploymentSimulationRequest,
    component: () => import("@/views/mw-deployment-simulation/SimulationView.vue")
  },
  {
    path: "/mw-deployment-simulation",
    redirect() {
      return { name: routeNames.mwDeploymentSimulationMain }
    }
  },

  {
    path: "/surveys",
    name: routeNames.surveysRoot,
    redirect() {
      return { name: routeNames.surveysList }
    }
  },
  {
    path: "/surveys/surveys-list",
    name: routeNames.surveysList,
    component: () => import("@/views/surveys/SurveysListView.vue")
  },
  {
    path: "/surveys/survey/:id",
    name: routeNames.survey,
    component: () => import("@/views/surveys/SurveyView.vue")
  },
  {
    path: "/surveys/survey-creator/:id?",
    name: routeNames.surveyCreator,
    component: () => import("@/views/surveys/SurveyCreatorView.vue")
  },
  {
    path: "/surveys/survey-results/:id",
    name: routeNames.surveyResults,
    component: () => import("@/views/surveys/SurveyResultsView.vue")
  },
  {
    path: "/surveys/admin-panel/:tab?/:subtab?",
    name: routeNames.surveysAdminPanel,
    component: () => import("@/views/surveys/AdminPanelView.vue")
  },

  {
    path: "/spectrum/view/:linkReference?",
    name: routeNames.spectrumMain,
    component: () => import("@/views/spectrum/MainView.vue")
  },
  {
    path: "/spectrum/admin-panel/:tab?/:subtab?",
    name: routeNames.spectrumAdminPanel,
    component: () => import("@/views/spectrum/AdminPanelView.vue")
  },

  {
    path: "/coverage-statistics",
    name: routeNames.coverageStatisticsRoot,
    redirect() {
      return { name: routeNames.coverageStatisticsMain }
    }
  },
  {
    path: "/coverage-statistics/view",
    name: routeNames.coverageStatisticsMain,
    component: () => import("@/views/coverage-statistics/MainView.vue")
  },
  {
    path: "/coverage-statistics/admin-panel/:tab?/:subtab?",
    name: routeNames.coverageStatisticsAdminPanel,
    component: () => import("@/views/coverage-statistics/AdminPanelView.vue")
  },
  {
    path: "/admin-sites/view",
    name: routeNames.adminSitesMain,
    component: () => import("@/views/admin-sites/MainView.vue")
  },
  {
    path: "/admin-sites/admin-panel/:tab?/:subtab?",
    name: routeNames.adminSitesAdminPanel,
    component: () => import("@/views/admin-sites/AdminPanelView.vue")
  },

  {
    path: "/type-approvals/existing",
    name: routeNames.typeApprovalsMain,
    component: () => import("@/views/type-approvals/MainView.vue")
  },
  {
    path: "/type-approvals/drafts",
    name: routeNames.typeApprovalsDrafts,
    component: () => import("@/views/type-approvals/DraftsListView.vue")
  },
  {
    path: "/type-approvals/new",
    name: routeNames.typeApprovalsApplication,
    component: () => import("@/views/type-approvals/ApplicationView.vue")
  },
  {
    path: "/type-approvals/edit/:id",
    name: routeNames.typeApprovalsEdit,
    component: () => import("@/views/type-approvals/ApplicationView.vue")
  },
  {
    path: "/type-approvals/view/:id",
    name: routeNames.typeApprovalsView,
    component: () => import("@/views/type-approvals/ApplicationView.vue")
  },
  {
    path: "/type-approvals/admin-panel/:tab?/:subtab?",
    name: routeNames.typeApprovalsAdminPanel,
    component: () => import("@/views/type-approvals/AdminPanelView.vue")
  },

  {
    path: "/bct-applications-requests/dashboard",
    name: routeNames.bctApplicationsDashboard,
    component: () => import("@/views/bct-applications-requests/DashboardView.vue")
  },
  {
    path: "/bct-applications-requests/drafts",
    name: routeNames.bctApplicationsDrafts,
    component: () => import("@/views/bct-applications-requests/DraftsListView.vue")
  },
  {
    path: "/bct-applications-requests/new/:requestType/:serviceType",
    name: routeNames.bctApplicationsNew,
    component: () => import("@/views/bct-applications-requests/RequestView.vue")
  },
  {
    path: "/bct-applications-requests/edit/:id",
    name: routeNames.bctApplicationsEdit,
    component: () => import("@/views/bct-applications-requests/RequestView.vue")
  },
  {
    path: "/bct-applications-requests/view/:id/:serviceType",
    name: routeNames.bctApplicationsView,
    component: () => import("@/views/bct-applications-requests/RequestView.vue")
  },
  {
    path: "/bct-applications-requests/admin-panel/:tab?/:subtab?",
    name: routeNames.bctApplicationsAdminPanel,
    component: () => import("@/views/bct-applications-requests/AdminPanelView.vue")
  },

  {
    path: "/comsis",
    name: routeNames.comsisRoot,
    component: () => import("@/views/comsis/DefaultRedirectView.vue")
  },
  {
    path: "/comsis/stations-list",
    name: routeNames.comsisStationsList,
    component: () => import("@/views/comsis/StationsListView.vue")
  },
  {
    path: "/comsis/stations-map",
    name: routeNames.comsisStationsMap,
    component: () => import("@/views/comsis/StationsMapView.vue")
  },
  {
    path: "/comsis/station/:mode/:id?/:tab?",
    name: routeNames.comsisStation,
    component: () => import("@/views/comsis/StationView.vue")
  },
  {
    path: "/comsis/request/:mode/:id?/:tab?",
    name: routeNames.comsisRequest,
    component: () => import("@/views/comsis/StationView.vue")
  },
  {
    path: "/comsis/requests-list",
    name: routeNames.comsisRequestsList,
    component: () => import("@/views/comsis/RequestsListView.vue")
  },
  {
    path: "/comsis/admin-panel/:tab?/:subtab?",
    name: routeNames.comsisAdminPanel,
    component: () => import("@/views/comsis/AdminPanelView.vue")
  }
]
